export const THEME_COLOR = "rgb(70,140,212)";

const LAYOUT = [];

export default LAYOUT;